import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import "../css/main.scss";
import productData from "../Datas/productData";
import siteConfig, { formatMoney } from "../siteConfig";

const slides = [
  ["/img/editorial/hero-1.jpg", "Stoneware, linen, glass and original art in warm daylight"],
  ["/img/editorial/hero-2.jpg", "Cotton pads and velvet cushion arranged on a timber bench"],
  ["/img/editorial/hero-3.jpg", "Jute rug, bamboo basket and zinc tray in a quiet hallway"],
];
const materialNotes = [
  ["Stoneware", "Glaze pooling, speckles and throwing lines make each fired piece individual."],
  ["Natural fibres", "Jute, cotton, wool and bamboo bring visible grain, weave and small tonal shifts."],
  ["Useful metals", "Zinc, iron and bronzed aluminium are chosen for stable forms and honest patina."],
];
const journal = [
  ["/img/editorial/journal-1.jpg", "A gentler routine for handmade ceramics", "/safety-care"],
  ["/img/editorial/journal-2.jpg", "Reading natural fibre by touch", "/product-accuracy"],
  ["/img/editorial/journal-3.jpg", "Packing fragile pieces with less excess", "/packaging"],
];

function Main() {
  const [slide, setSlide] = useState(0);
  useEffect(() => {
    const timer = window.setInterval(() => setSlide((value) => (value + 1) % slides.length), 5500);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className="main">
      <main>
        <section className="hero" aria-label="Featured material collection">
          {slides.map(([image, alt], index) => <img key={image} className={index === slide ? "active" : ""} src={image} alt={alt} />)}
          <div className="hero-dots">{slides.map((_, index) => <button key={index} aria-label={`Show slide ${index + 1}`} className={index === slide ? "active" : ""} onClick={() => setSlide(index)} />)}</div>
        </section>

        <section className="opening-intro section-pad">
          <p>Designed to be understood before it reaches your home.</p>
          <h1>Materials, purpose and care at a glance</h1>
          <div className="calendar-card material-guide">
            <div className="calendar-head"><p className="eyebrow">A practical edit</p><h2>Choose by how a piece will live</h2></div>
            <div className="material-guide-grid"><article><span>01</span><h3>Measure first</h3><p>Check dimensions, capacity and placement against the product page.</p></article><article><span>02</span><h3>Read the material</h3><p>Natural fibres and reactive glazes vary; the listing explains what to expect.</p></article><article><span>03</span><h3>Use it safely</h3><p>Care and bilingual safety notes travel with every catalog description.</p></article></div>
            <Link className="text-link" to="/product-accuracy">Read the product guide <FiArrowRight /></Link>
          </div>
        </section>

        <section className="featured section-pad">
          <div className="section-heading"><div><p className="eyebrow">Chosen for now</p><h2>New in the shop</h2></div><Link to="/shop">View all <FiArrowRight /></Link></div>
          <div className="product-row">{productData.slice(10, 16).map((product) => <Link to={`/shopDetails/${product.id}`} className="home-product" key={product.id}><div><img loading="lazy" src={product.image} alt={product.name} /></div><h3>{product.name}</h3><p>{formatMoney(product.price)}</p></Link>)}</div>
        </section>

        <section className="story-band"><div><p className="eyebrow">Material-led & useful</p><h2>Objects chosen for real rooms.</h2><p>{siteConfig.brandName} focuses on scale, texture, care and everyday purpose. The catalog says what a product is made from, how it can vary and where extra caution matters.</p><Link className="text-link" to="/about">Our approach <FiArrowRight /></Link></div><img loading="lazy" src="/img/editorial/story.jpg" alt="Glass candle holder, stoneware mug and linen on a burgundy shelf" /></section>

        <section className="reviews section-pad"><p className="eyebrow">Material notes</p><div>{materialNotes.map(([title, note]) => <article key={title}><span aria-hidden="true">◇</span><h3>{title}</h3><p>{note}</p></article>)}</div></section>

        <section className="journal section-pad"><div className="section-heading"><div><p className="eyebrow">Read + discover</p><h2>{siteConfig.brandName} material journal</h2></div></div><div className="journal-grid">{journal.map(([image, title, path]) => <article key={title}><img loading="lazy" src={image} alt="" /><p className="eyebrow">Guide</p><h3>{title}</h3><Link to={path}>Read guide <FiArrowRight /></Link></article>)}</div></section>

        <section className="find-us section-pad"><p className="eyebrow">Customer care</p><h2>Questions before or after an order</h2><div className="find-grid"><div><h3>{siteConfig.operatingRegion} storefront<br />{siteConfig.currency} checkout<br />{siteConfig.timezone}</h3><p>Product, material, safety, delivery and policy questions are handled by email. Do not send card information.</p></div><div><h3>Email us</h3><p><a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a></p><Link className="button-link" to="/contact">Contact details</Link></div></div></section>
      </main>
    </div>
  );
}

export default Main;
